import React from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";

import Navbar from "./components/Navbar";
import TopNavbar from "./components/TopNavbar";
import Footer from "./components/Footer";
import Slider from "./components/Slider";

import HomePage from "./pages/HomePage";
import PageDetail from "./pages/PageDetail";
import Staff from "./pages/Staff";
import NewPageDetail from "./pages/NewPageDetail";
import Programs from "./pages/Programs";
import Fanlar from "./pages/Fanlar";
import FanDetail from "./pages/FanDetail";
import Researchgrid from "./pages/Researchgrid";
import Department from "./pages/Department";
import NewsSection from "./pages/NewsSection";

function App() {
  return (
    <BrowserRouter>
      <div
        style={{
          minHeight: "100vh",
          display: "flex",
          flexDirection: "column",
        }}
      >
        {/* 🔝 Navbar barcha sahifalarda */}
        <Navbar />

        <main style={{ flex: 1 }}>
          <Routes>
            {/* 🏠 Asosiy sahifa */}
            <Route
              path="/"
              element={
                <>
                  <Slider />
                  <HomePage />
                  <Researchgrid />
                  <Department />
                  <NewsSection />
                </>
              }
            />

            {/* 📄 Sahifalar */}
            <Route path="/pages/:id" element={<PageDetail />} />
            <Route path="/newpages/:id" element={<NewPageDetail />} />

            {/* 📚 Bo‘limlar */}
            <Route path="/staff" element={<Staff />} />
            <Route path="/programs" element={<Programs />} />
            <Route path="/fanlar" element={<Fanlar />} />
            <Route path="/fanlar/:id" element={<FanDetail />} />

            {/* 🔝 Test sahifa */}
            <Route path="/top-navbar" element={<TopNavbar />} />
          </Routes>
        </main>

        {/* ⬇ Footer har doim pastda */}
        <Footer />
      </div>
    </BrowserRouter>
  );
}

export default App;
